/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2025-04-12 02:45:51
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-04-15 21:46:29
 * @FilePath: \zeelool-nextjs\src\components\Product\member.tsx
 * @Description: 会员等级标签展示层
 */
import { useStore } from '@/providers/app-store-provider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import { ResponsiveContext } from '../Responsive/ResponsiveProvider';

const MemberTag = ({ level, className = '' }: { level: number; className?: string }) => {
  const { deviceType } = useContext(ResponsiveContext);
  const t = useTranslations('product');
  const memberLevelConfig = useStore((state) => state.memberLevelConfig);
  const memberLevelName =
    memberLevelConfig.find((item) => item.member_level === level)?.member_level_name || '';
  const style = { fontSize: ' max(.7291666667vw, 11px)' };
  if (level === 0) {
    return (
      <span
        className={`bg-[#F0DBD8] pl-6 pr-6 ${deviceType === EPlatform.WEB ? 'leading-16 text-12 rounded-4 mr-6' : 'leading-[15px] text-11 rounded-4 mr-8'} ${className}`}
        style={style}
      >
        {memberLevelName || t('member.v0')}
      </span>
    );
  }
  if (level === 1) {
    return (
      <span
        className={`bg-[#D8E3F0] pl-6 pr-6 ${deviceType === EPlatform.WEB ? 'leading-16 text-12 rounded-4 mr-6' : 'leading-[15px] text-11 rounded-4 mr-8'} ${className}`}
        style={style}
      >
        {memberLevelName || t('member.v1')}
      </span>
    );
  }
  if (level === 2) {
    return (
      <span
        className={`bg-[#FCDDB6]  pl-6 pr-6 ${deviceType === EPlatform.WEB ? 'leading-16 text-12 rounded-4 mr-6' : 'leading-[15px] text-11 rounded-4 mr-8'} ${className}`}
        style={style}
      >
        {memberLevelName || t('member.v2')}
      </span>
    );
  }
  if (level === 3) {
    return (
      <span
        className={`bg-gradient-to-r from-[#E4DFFF] to-[#BCBCFF]  pl-6 pr-6 ${deviceType === EPlatform.WEB ? 'leading-16 text-12 rounded-4 mr-6' : 'leading-[15px] text-11 rounded-4 mr-8'} ${className}`}
        style={style}
      >
        {memberLevelName || t('member.v3')}
      </span>
    );
  }
  return <></>;
};

export default MemberTag;
